module.exports = __webpack_public_path__ + "img/visa.b375eb9.svg";